<template>
    <div id = "main">
        <h2>
            {{ title }}
        </h2>

        <ul v-for="(item, index) in booksData" :key="index">
            <h2>{{$translation.L(item.categoryName)}}</h2>
            <li v-for="(item2, index2) in item.books" :key="index2">
                <h1>{{item2}}</h1>
            </li>
        </ul>
        <div class="space"></div>
    </div>
</template>

<script>
export default {
  name: 'books',
  data() {
    return {
      booksData: this.$config.books,
      title: this.$translation.L('MENU_BOOKS'),
    };
  },
};
</script>

<style scoped>

    * {
        word-break: keep-all;
    }

    #main {
        display: block;
        width: 100%;
        height: 80%;
        background-color: white;
        padding: 5px 0;
        word-break: break-all;
    }

    h2 {
        margin-top: 10px;
        color: #333;
        font-size: 2.5vw;
        border-bottom: 1px solid #333;
        max-width: 90%;
        margin-left: auto;
        margin-right: auto;
    }

    ul {
        display: block;
        width: 80%;
        margin: 0 auto;
    }

    ul li {
        color: #333;
        font-size: 0.6vw;
        margin-top: 20px;
        text-align: left;
    }

    ul h2 {
        margin-top: 10px;
        color: #333;
        font-size: 2.1vw;
        border-bottom: 1px solid #333;
    }

    .space {
        height: 4vw;
        width: 100%;
    }

    @media only screen and (max-width: 1023px) {
        h2 {
            font-size: 4vw;
        }

        ul li {
            font-size: 1.6vw;
        }

        ul h2 {
            margin-top: 10px;
            color: #333;
            font-size: 3.3vw;
            border-bottom: 1px solid #333;
            margin: 30px;
        }
    }
</style>
